if showIcon
  .input-group.date.g-datetime-widget
    input.input-sm.form-control(type="text")
    span.input-group-addon
      span.icon-calendar
else
  .input-group
    input.input-sm.form-control.g-datetime-widget(type="text")
